// ipfs.io and dweb.link stopped serving content on 2026-09-21
// https://ipshipyard.com/blog/2026-the-end-of-ipfs-at-shipyard/
export const IPFS_GATEWAY = "https://ipfs.filebase.io/ipfs";
